export default __webpack_public_path__ + "static/media/Icondamacai.86e831e8.png";